import React from "react";
import Skeleton from "react-loading-skeleton";

/**
 * Loading placeholder for the full-page Power BI report view.
 * @returns {JSX.Element}
 */
const SkeletonReportPreview = () => {
  return (
    <div className="report-preview-skeleton w-100">
      <div className="report-preview-skeleton__canvas">
        <Skeleton className="report-preview-skeleton__embed" />
      </div>
    </div>
  );
};

export default SkeletonReportPreview;
